import { searchRules, typeCondition } from './targetSearch';
export default {
  target: { searchRules, typeCondition }
};